import angular from 'angular'
import moment from 'moment'
import templateUrl from "./rogers-slippage-detail-report.component.html";
import { containsInvariant } from '../../../core/services/filter-util';

export const RogersSlippageDetailReportComponent = {
    templateUrl,
    bindings: {
        slippageReport: "<",
        onUpdateStatus: "&"
    },
    controller: class {
        constructor() {
            'ngInject'
            this.pageNumber = 1;
            this.pageSize = 10;
            this.filters = {};
        }

        $onInit() {
        }

        $onChanges(changes) {
            if (changes.slippageReport && changes.slippageReport.currentValue) {
                this.filteredReport = changes.slippageReport.currentValue.filter(p => this.filterReport(p));
            }
        }

        updateStatus(productOrder) {
            this.onUpdateStatus({
                $event: {
                    productOrder
                }
            });
        }

        onChangeFilter() {
            this.pageNumber = 1;
            this.filteredReport = angular.copy(this.slippageReport);
            this.filteredReport = this.slippageReport.filter(p => this.filterReport(p));
        }

        filterReport(data) {

            return (!this.filters.OwnerName || containsInvariant(data.OwnerName, this.filters.OwnerName))
                && (!this.filters.RepName || containsInvariant(data.RepName, this.filters.RepName))
                && (!this.filters.SgiID || containsInvariant(data.SgiID, this.filters.SgiID))
                && (!this.filters.AccountNumber || containsInvariant(data.AccountNumber, this.filters.AccountNumber))
                && (!this.filters.CustomerName || containsInvariant(data.CustomerName, this.filters.CustomerName))
                && (!this.filters.CustomerAddress ||
                    containsInvariant(data.CustomerAddress, this.filters.CustomerAddress))
                && (!this.filters.ProductLineCode ||
                    containsInvariant(data.ProductLineCode, this.filters.ProductLineCode))
                && (!this.filters.ProductName || containsInvariant(data.ProductName, this.filters.ProductName))
                && (!this.filters.ProductCode || containsInvariant(data.ProductCode, this.filters.ProductCode))
                && (!this.filters.Notes || containsInvariant(data.Notes, this.filters.Notes))
                && (!this.filters.BookedDate || moment(this.filters.BookedDate).isSame(data.BookedDate, "day"))
                && (!this.filters.StatusDate || moment(this.filters.StatusDate).isSame(data.StatusDate, "day"))
                && (!this.filters.StatusName || containsInvariant(data.StatusName, this.filters.StatusName));
        }

    }
}

